document.addEventListener("DOMContentLoaded", async () => {
  if (!window.currentProduct) {
    console.error("Kein Produkt gefunden. Abbruch.");
    return;
  }

  async function fetchRelatedProducts(currentProduct) {
    try {
      const response = await fetch("https://kofferpunktshop.myshopify.com/api/2024-10/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": "85dd183f2739416972613bf5ef86ba0a",
        },
        body: JSON.stringify({
          query: `
            query getProducts($first: Int, $query: String) {
              products(first: $first, query: $query) {
                edges {
                  node {
                    id
                    title
                    inventory_quantity: totalInventory
                    handle
                    featuredImage { url }
                    selectedOrFirstAvailableVariant {
                      availableForSale
                      price { amount currencyCode }
                    }
                    color_metafield: metafield(namespace: "akeneo", key: "at_farbbezeichnung_des_hers__1") { value }
                    custom_size_metafield: metafield(namespace: "akeneo", key: "gr__e_textfeld") { value }
                    size_group_value_metafield: metafield(namespace: "akeneo", key: "size_group_value") { value }
                  }
                }
              }
            }`,
          variables: {
            first: 100,
            query: `tag:"parent:${currentProduct.parent_article}" OR tag:"size-group:${currentProduct.size_group}"`
          }
        })
      });

      const data = await response.json();

      if (!response.ok) {
        console.error("Fehler bei der API-Abfrage:", data);
        return [];
      }

      return data.data.products.edges.map(el => ({
        ...el.node,
        custom_size: el.node.custom_size_metafield?.value || el.node.size_group_value_metafield?.value || "onesize",
        color: el.node.color_metafield?.value,
        inventory_quantity: el.node.inventory_quantity
      }));
    } catch (error) {
      console.error("Fehler beim Abrufen der Varianten:", error);
      return [];
    }
  }

  function renderVariantOptions(currentProduct, options, selector, displayImage, availableProducts) {
    let template = '';
    options.sort((a, b) => (a.custom_size || "").localeCompare(b.custom_size || "", undefined, { numeric: true }));

    options.forEach(el => {
      let classList = '';
      let isCurrent = displayImage
        ? (currentProduct.color?.trim().toLowerCase() === el.color?.trim().toLowerCase())
        : (currentProduct.custom_size?.trim().toLowerCase() === el.custom_size?.trim().toLowerCase());

      let availableProduct = availableProducts.find(p => 
        (displayImage
          ? (p.custom_size?.trim().toLowerCase() === currentProduct.custom_size?.trim().toLowerCase() &&
             p.color?.trim().toLowerCase() === el.color?.trim().toLowerCase())
          : (p.custom_size?.trim().toLowerCase() === el.custom_size?.trim().toLowerCase() &&
             p.color?.trim().toLowerCase() === currentProduct.color?.trim().toLowerCase()))
      );

      if (!availableProduct || availableProduct.inventory_quantity <= 0) return;

      if (!availableProduct.selectedOrFirstAvailableVariant?.availableForSale) classList += ' sold-out';
      if (isCurrent) classList += ' current';

      let price = availableProduct?.selectedOrFirstAvailableVariant?.price?.amount;
      price = price ? parseFloat(price).toFixed(2) + " €" : "";

      let imageElement = `<img src="${availableProduct.featuredImage?.url}" width="100" height="100"><p>${price}</p>`;
      let innerElement = displayImage ? imageElement : el.custom_size;

      template += isCurrent
        ? `<span class="${classList}">${innerElement}</span>`
        : `<a href="/products/${availableProduct.handle}" class="${classList}" title="${el.title}">${innerElement}</a>`;
    });

    const targetElement = document.querySelector(selector);
    if (targetElement) {
      targetElement.innerHTML = template;
    }
  }

  async function initVariantSelector() {
    const currentProduct = window.currentProduct;
    console.log("Lade Varianten für Produkt:", currentProduct);

    const relatedProducts = await fetchRelatedProducts(currentProduct);

    if (!relatedProducts.length) {
      console.warn("Keine verwandten Produkte gefunden.");
      return;
    }

    const displayedSizes = [];
    const displayedColors = [];
    const productSizes = [];
    const productColors = [];

    relatedProducts.forEach(product => {
      if (!displayedSizes.includes(product.custom_size)) {
        displayedSizes.push(product.custom_size);
        productSizes.push(product);
      }
      if (product.color && !displayedColors.includes(product.color)) {
        displayedColors.push(product.color);
        productColors.push(product);
      }
    });

    document.querySelector(".color-selector .variant-selector-loader")?.remove();
    document.querySelector(".size-selector .variant-selector-loader")?.remove();

    if (!displayedColors.length) document.querySelector(".color-selector")?.remove();
    if (!displayedSizes.length) document.querySelector(".size-selector")?.remove();

    renderVariantOptions(currentProduct, productColors, "#color-options", true, relatedProducts);
    renderVariantOptions(currentProduct, productSizes, "#size-options", false, relatedProducts);
  }

  initVariantSelector();
});
